/* eslint-disable */
import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import SuccessModal from "../../components/Modal/successModal";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
//import Breadcrumbs
import { Form, Button, Select } from "antd";
import { DownOutlined, CloseOutlined } from "@ant-design/icons";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Container, FormGroup, Input } from "reactstrap";
import PencilIcon from "../../assets/images/pencil.png";
import { createCustomer } from "../../data/customer.js";
import * as ST from "./styles";
import { openNotificationWithIcon } from "../../components/Modal/notification";
import { getCompanyInfo } from "../../data/comany";
import usStates from "../../constants/usStates.js";

const { Option } = Select;
const phoneCheck = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
const Projects = () => {
  const [modal_center, setmodal_center] = useState(false);
  const [companyInfo, setCompanyInfo] = useState();
  const history = useHistory();

  const { currentUser, currentCompany } = useSelector((state) => ({
    currentUser: state.Login.user,
    currentCompany: state.Login.company,
  }));

  useEffect(() => {
    getCompanyInfo({ id: currentUser?.company_id }).then((res) => {
      if (res) {
        setCompanyInfo(res[0]?.discount?.split(","));
      }
    });
  }, []);
  const validRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const tog_center = () => {
    setmodal_center(!modal_center);
  };

  const goBack = () => {
    history.push("/customers");
  };
  const handleSubmit = (val) => {
    if (
      currentCompany?.trialEndDate < Math.floor(Date.now() / 1000) &&
      !currentCompany?.session_id
    ) {
      openNotificationWithIcon(
        "error",
        "Note",
        "You must have an active subscription or trial to use this feature."
      );
      return;
    }

    if (val.contacts) {
      val.contacts = JSON.stringify(val.contacts)
    }
    if (currentUser.role_id !== 9 && currentUser.role_id !== 10) {
      const data = val;
      data.company_id = currentUser.company_id;
      data.state = data?.state?.toUpperCase();
      createCustomer(val)
        .then((res) => {
          openNotificationWithIcon("success", "Note", "Created successfully");
          history.push("/customers");
        })
        .catch((err) => {
          openNotificationWithIcon("error", "Note", "Failed");
        });
    } else {
      openNotificationWithIcon(
        "error",
        "Note",
        "You must be a part of a company before using this feature."
      );
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add Customer | DOP Test Network</title>
        </MetaTags>
        {currentUser?.role_id !== 10 && (
          <ST.Wrapper>
            <Container fluid>
              {/* Render Breadcrumbs */}
              <Breadcrumbs title="DOP" breadcrumbItem="Add Customer" />
              <header className="back d-print-none" onClick={() => goBack()}>
                <i className="dripicons-arrow-thin-left"></i>
                <span>Back</span>
              </header>
              <div className="row header">
                <div className="col-md-12">Add Customer</div>
              </div>
              <Form onFinish={handleSubmit}>
                <div className="row">
                  <div className="col-md-1"></div>
                  <div className="col-md-5">
                    <Form.Item
                      name="customer_name"
                      rules={[
                        { required: true, message: "This field is required" },
                      ]}
                    >
                      <FormGroup>
                        <Input />
                        <span className="inputTitle">Company Name</span>
                        <img src={PencilIcon} alt="" />
                      </FormGroup>
                    </Form.Item>
                    <div className="row" style={{ marginTop: 0 }}>
                      <div className="col-md-6">
                        <Form.Item
                          name="customer_email"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              validator(_, value) {
                                if (value && !value.match(validRegex)) {
                                  return Promise.reject(
                                    "Invalid email address!"
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <FormGroup>
                            <Input />
                            <span className="inputTitle">Email Address</span>
                            <img src={PencilIcon} alt="" />
                          </FormGroup>
                        </Form.Item>
                      </div>

                      <div className="col-md-6">
                        <Form.Item
                          name="customer_phone"
                          rules={[
                            {
                              validator(_, value) {
                                if (value && !phoneCheck.test(value)) {
                                  return Promise.reject(
                                    "Invalid phone number!"
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <FormGroup>
                            <Input />
                            <span className="inputTitle">Phone Number</span>
                            <img src={PencilIcon} alt="" />
                          </FormGroup>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: 0 }}>
                      <div className="col-md-12">
                        <Form.Item
                          name="terms"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                        >
                          <FormGroup>
                            <Input type="select">
                              <option></option>
                              <option value="Due on receipt">
                                Due on receipt
                              </option>
                              <option value="Net 15">Net 15</option>
                              <option value="Net 30">Net 30</option>
                            </Input>
                            <span className="inputTitle">Terms</span>
                            <DownOutlined />
                          </FormGroup>
                        </Form.Item>
                      </div>
                      <div className="col-md-12">
                        <Form.Item name="discount">
                          <FormGroup>
                            <Input type="select">
                              <option value="N/A">N/A</option>
                              {companyInfo &&
                                companyInfo.map((res) => (
                                  <option value={res} key={res}>
                                    {res}%
                                  </option>
                                ))}
                            </Input>
                            <span className="inputTitle">
                              Discount Allegibillity
                            </span>
                            <DownOutlined />
                          </FormGroup>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <Form.Item name="street">
                      <FormGroup>
                        <Input />
                        <span className="inputTitle">Street</span>
                        <img src={PencilIcon} alt="" />
                      </FormGroup>
                    </Form.Item>
                    <Form.Item name="city">
                      <FormGroup>
                        <Input />
                        <span className="inputTitle">City</span>
                        <img src={PencilIcon} alt="" />
                      </FormGroup>
                    </Form.Item>
                    <Form.Item
                      name="state"
                      // rules={[
                      //   { pattern: /^[A-Za-z]{2}$/, message: 'Please enter a valid two-letter state abbreviation' },
                      // ]}
                    >
                      <Select
                        showSearch
                        className="antdSelect"
                        placeholder="Search to States"
                        options={usStates}
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      name="zip"
                      rules={[
                        {
                          pattern: /^\d{5}(-\d{4})?$/,
                          message:
                            "Please enter a valid ZIP code (XXXXX or XXXXX-XXXX)",
                        },
                      ]}
                    >
                      <FormGroup>
                        <Input />
                        <span className="inputTitle">Zip</span>
                        <img src={PencilIcon} alt="" />
                      </FormGroup>
                    </Form.Item>
                  </div>
                  <div className="col-md-1"></div>
                </div>
                <Form.List name="contacts">
                  {(fields, { add, remove }) => (
                    <div>
                      {fields.map(({ key, name, ...restField }) => (
                        <div
                          key={key}
                          className="row"
                          style={{
                            marginTop: -30,
                            display: "flex",
                            alignItems: "baseline",
                          }}
                        >
                          <div className="col-md-1"></div>
                          <div className="col-md-10">
                            <div className="row">
                              <div className="col-md-4">
                                <Form.Item
                                  {...restField}
                                  name={[name, "contact_firstname"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                >
                                  <FormGroup>
                                    <Input />
                                    <span className="inputTitle">
                                      Contact First Name
                                    </span>
                                    <img src={PencilIcon} alt="" />
                                  </FormGroup>
                                </Form.Item>
                              </div>
                              <div className="col-md-4">
                                <Form.Item
                                  {...restField}
                                  name={[name, "contact_lastname"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                >
                                  <FormGroup>
                                    <Input />
                                    <span className="inputTitle">
                                      Contact Last Name
                                    </span>
                                    <img src={PencilIcon} alt="" />
                                  </FormGroup>
                                </Form.Item>
                              </div>
                              <div className="col-md-4">
                                <Form.Item
                                  {...restField}
                                  name={[name, "contact_email"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      validator(_, value) {
                                        if (value && !value.match(validRegex)) {
                                          return Promise.reject(
                                            "Invalid email address!"
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    },
                                  ]}
                                >
                                  <FormGroup>
                                    <Input />
                                    <span className="inputTitle">
                                      Contact Email
                                    </span>
                                    <img src={PencilIcon} alt="" />
                                  </FormGroup>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <CloseOutlined
                              onClick={() => remove(name)}
                            />
                          </div>
                        </div>
                      ))}
                      <div className="row" style={{ marginTop: -10 }}>
                        <div className="col-md-1"></div>
                        <div className="col-md-10">
                          <Button type="dashed" onClick={() => add()} block>
                            + Add Other Contact
                          </Button>
                        </div>
                        <div className="col-md-1"></div>
                      </div>
                    </div>
                  )}
                </Form.List>
                <div className="row">
                  <div className="col-md-5">
                    <Button htmlType="submit">Save & New</Button>
                  </div>
                </div>
              </Form>
            </Container>
            <SuccessModal
              title="Successfully!"
              content="Customer Added"
              modal_center={modal_center}
              setmodal_center={setmodal_center}
              tog_center={tog_center}
            />
          </ST.Wrapper>
        )}
      </div>
    </React.Fragment>
  );
};

export default Projects;
